<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  notaries: { type: Array, default: () => [] },
  value: { type: Object, required: true },
});

const emit = defineEmits(['update:value']);
const { t } = useI18n();

const update = (field, value) =>
  emit('update:value', { ...props.value, [field]: value });

const selectNotary = id => {
  const notary = props.notaries.find(entry => String(entry.id) === String(id));
  if (!notary || String(id) === '-1') {
    emit('update:value', {
      ...props.value,
      local_escritura: String(id),
      nome_cartorio: '',
    });
    return;
  }

  emit('update:value', {
    ...props.value,
    local_escritura: String(notary.id),
    nome_cartorio: notary.name,
    cep_escritura: notary.cep || '',
    endereco_escritura: notary.logradouro || '',
    cidade_escritura: notary.cidade || '',
    bairro_escritura: notary.bairro || '',
    estado_escritura: notary.uf || '',
    numero_escritura: notary.numero || '',
    complemento_escritura: notary.complemento || '',
  });
};
</script>

<template>
  <section class="grid gap-4">
    <h2 class="text-lg font-semibold text-lais-text">
      {{ t('POST_SALE.FORM.DEED.LOCATION_TITLE') }}
    </h2>
    <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
      {{ t('POST_SALE.FORM.DEED.NOTARY') }}
      <select
        :value="value.local_escritura"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-2 font-normal"
        @change="selectNotary($event.target.value)"
      >
        <option value="">{{ t('POST_SALE.FORM.SELECT') }}</option>
        <option v-for="notary in notaries" :key="notary.id" :value="notary.id">
          {{ notary.name }}
        </option>
      </select>
    </label>
    <label
      v-if="String(value.local_escritura) === '-1'"
      class="grid gap-1 text-sm font-semibold text-lais-text-body"
    >
      {{ t('POST_SALE.FORM.DEED.OTHER_NOTARY') }}
      <input
        :value="value.nome_cartorio"
        :placeholder="t('POST_SALE.FORM.DEED.OTHER_NOTARY_PLACEHOLDER')"
        class="min-h-10 rounded-lais border border-lais-border px-2 font-normal"
        @input="update('nome_cartorio', $event.target.value)"
      />
    </label>
  </section>
</template>
